<template>
  <CRow>
    <CCol col="12" xl="12">
        <CButtonToolbar>
          <CButton 
            color="ghost-success" 
            shape="pill"
            @click="showSectionEditor=true"
          >
            <CIcon size="lg" name="cil-pen"/>
          </CButton>
        </CButtonToolbar>
      </CCol>
    <CCol col="12">
      <CCard>
        <CCardBody>
          <AppForm 
            :key="appFormKey"
            :vo-name="isEdit ? 'ProductGetVo' : 'ProductAddVo'"
            :data="tmpProduct" 
            @changed="onFormChange"
          />
        </CCardBody>
        <CCardFooter>
          <LoadingStateButton
            @click="onAddOrUpdateProduct"
            :text="i18nMessage.Apply"
            color="primary"
            :loading="updateProductLoading"
          />
          <template v-if="isEdit">
            &nbsp;
            <CButton color="secondary" @click="showDeleteModal = true">{{i18nMessage.Delete}}</CButton>
          </template>
          &nbsp;
          <CButton color="secondary" @click="goBack">{{i18nMessage.Back}}</CButton>
        </CCardFooter>
      </CCard>
    </CCol>
    <CModal
      :show.sync="showDeleteModal"
      :centered="true"
      color="default"
    >
      {{i18nMessage.PleaseInputTextToConfirmDelete}} <b>{{product.name}}</b>
      <br/><br/>
      <CInput
          :placeholder="i18nMessage.PleaseInputText"
          v-model="deleteConfirmText"
        />
      <template #header>
        <span class="modal-title">{{i18nMessage.Delete}}？</span>
        <CButtonClose @click="showDeleteModal = false" class="text-dark"/>
      </template>
      <template #footer>
        <LoadingStateButton
          :disabled="deleteConfirmText !== product.name"
          @click="onDeleteProduct"
          :text="i18nMessage.Apply"
          color="danger"
          :loading="deleteProductLoading"
        />
        <CButton @click="showDeleteModal = false" color="secondary">{{i18nMessage.Cancel}}</CButton>
      </template>
    </CModal>
    <CModal
      :addContentClasses="'overlay bg-white section-modal'"
      :fade="false"
      id="section-editor-modal"
      title="Section Editor"
      :show.sync="showSectionEditor"
    >
      <HtmlEditor
        id="product-editor"
        v-if="showSectionEditor"
        :content="(tmpProduct.desc_html ? tmpProduct.desc_html  : ' ') + '<style>' + (tmpProduct.desc_style ? tmpProduct.desc_style : '') + '</style>'"
        :global-styles="defaultGlobalStyles"
        @change="onEditorContentChange"
      />
    </CModal>
  </CRow>
</template>

<script>
import { mapState, mapActions, mapMutations, } from 'vuex'
import { generateGUID } from '../../util'
import AppForm from '../../components/AppForm'
import LoadingStateButton from '../../components/LoadingStateButton'
import HtmlEditor from '../../components/HtmlEditor'

export default {
  name: 'Product',
  components: {
    AppForm,
    LoadingStateButton,
    HtmlEditor,
  },
  data () {
    return {
      deleteConfirmText: null,
      showDeleteModal: false,
      isEdit: this.$route.params.id && this.$route.params.id.length > 0,
      tmpProduct: {},
      updateProductLoading: false,
      deleteProductLoading: false,
      appFormKey: generateGUID(),
      showSectionEditor: false,
    }
  },
  computed: {
    ...mapState({
      i18nMessage: state => state.i18nMessage,
      product: state => state.product.product,
      defaultGlobalStyles: state => state.defaultGlobalStyles,
    }),
  },
  methods: {
    ...mapActions({
      getProduct: 'product/getProduct',
      updateProduct: 'product/updateProduct',
      addProduct: 'product/addProduct',
      deleteProduct: 'product/deleteProduct',
    }),
    ...mapMutations({
      setProduct: 'product/setProduct',
    }),
    goBack() {
      this.$router.push({path: '/product'})
    },
    onFormChange (data) {
      this.tmpProduct = {...data}
    },
    onEditorContentChange (template, style) {
      this.tmpProduct = {
        ...this.tmpProduct,
        desc_html: template,
        desc_style: style,
      }
    },
    onAddOrUpdateProduct () {
      if (this.tmpProduct.id) {
        this.updateProductLoading = true
        this.updateProduct(this.tmpProduct)
          .then(() => {
            this.updateProductLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.updateProductLoading = false
          })
      } else {
        this.updateProductLoading = true
        this.addProduct(this.tmpProduct)
          .then(() => {
            this.updateProductLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.updateProductLoading = false
          })
      }
    },
    onDeleteProduct () {
      this.deleteProductLoading = true
      this.deleteProduct(this.product.id)
          .then(() => {
            this.deleteProductLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.deleteProductLoading = false
            this.showDeleteModal = false
          })
    }
  },
  mounted() {
    if (this.isEdit) {
      this.getProduct(this.$route.params.id).then(() => {
        this.tmpProduct = this.product
      })
    }
  },
  destroyed() {
    this.setProduct({})
  }
}
</script>

<style>
  .section-modal.overlay {
    position: fixed;
    width: 100%;
    height: 100vh;
    left: 0;
    top: 0;
    background: rgba(51,51,51,0.7);
    z-index: 10;
  }

  .section-modal > .modal-header {
    padding: 5px;
  }

  .section-modal > .modal-content {
    overflow: hidden;
  }

  .section-modal > .modal-body {
    overflow-y: scroll;
    padding: 0px;
  }

  .section-modal > .modal-footer {
    display: none;
  }
</style>